var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChatbotGuyTransparent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 149,
    height: 197,
    viewBox: "0 0 149 197"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "chatbot-guy-transparent_svg__a",
    d: "M65.934.61C29.554.61.063 30.214.063 66.733c0 36.518 29.491 66.122 65.87 66.122 36.381 0 65.873-29.604 65.873-66.122 0-36.52-29.492-66.123-65.872-66.123z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M60.242 75.083a2.216 2.216 0 11-2.215-2.216c1.223 0 2.215.992 2.215 2.216"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 64)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "chatbot-guy-transparent_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chatbot-guy-transparent_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    opacity: 0.36,
    xlinkHref: "#chatbot-guy-transparent_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7F1",
    d: "M55.414 110.894h21.044V96.72H55.414z",
    mask: "url(#chatbot-guy-transparent_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF4D1",
    d: "M64.345 41.94v-9.597c-1.842-.656 5.02-.652 3.174.006v9.592c3.713 0 9.422 6.03 9.422 12.563H54.93c0-6.533 4.743-12.563 9.415-12.563",
    mask: "url(#chatbot-guy-transparent_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M105.377 82.033c0 13.89-5.473 19.378-19.31 19.378H45.805c-13.839 0-19.304-5.489-19.304-19.378v-18.97c0-13.889 5.465-19.377 19.304-19.377h40.26c13.838 0 19.311 5.488 19.311 19.377v18.97",
    mask: "url(#chatbot-guy-transparent_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7F1",
    d: "M86.066 43.686H81.97c13.838 0 19.311 5.488 19.311 19.377v18.97c0 13.89-5.473 19.378-19.311 19.378h4.096c13.838 0 19.311-5.489 19.311-19.378v-18.97c0-13.889-5.473-19.377-19.31-19.377",
    mask: "url(#chatbot-guy-transparent_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7F1",
    d: "M101.345 61.044c5.06.694 8.746.815 8.746 10.82 0 9.817-3.35 9.853-8.049 10.705l-.697-21.525",
    mask: "url(#chatbot-guy-transparent_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M30.524 61.044c-5.063.694-8.746.815-8.746 10.82 0 9.817 3.35 9.853 8.048 10.705l.698-21.525m55.536 47.124H45.798c-13.839 0-19.303 5.487-19.303 19.376v7.643h78.876v-7.643c0-13.889-5.473-19.376-19.313-19.376",
    mask: "url(#chatbot-guy-transparent_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E7F1",
    d: "M86.06 108.168h-4.682c12.236 0 17.932 4.291 19.088 14.883a145.577 145.577 0 004.227-2.849c-1.843-8.52-7.56-12.034-18.634-12.034",
    mask: "url(#chatbot-guy-transparent_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD98B",
    d: "M36.22 76.659v-8.223c0-8.543 2.828-11.382 11.34-11.382h36.751c8.45 0 11.236 2.736 11.337 11.19v8.415c0 8.543-2.822 11.385-11.337 11.385h-36.75c-8.513 0-11.34-2.842-11.34-11.385z",
    mask: "url(#chatbot-guy-transparent_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M75.64 72.549a4.142 4.142 0 014.132-4.145 4.138 4.138 0 014.138 4.145 4.136 4.136 0 11-8.27 0m-27.675 0a4.135 4.135 0 014.128-4.145 4.137 4.137 0 014.133 4.145 4.135 4.135 0 01-4.133 4.146 4.133 4.133 0 01-4.128-4.146m22.721-44.69c0-2.634-2.124-4.767-4.747-4.767-2.621 0-4.747 2.133-4.747 4.767 0 2.632 2.126 4.765 4.747 4.765 2.623 0 4.747-2.133 4.747-4.765m6.257 22.631c-.711-5.218-.833-9.012-11.066-9.012-10.04 0-10.076 3.45-10.948 8.293l22.014.72",
    mask: "url(#chatbot-guy-transparent_svg__b)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.5,
    cy: 55,
    fill: "#FFFFFE",
    rx: 5.5,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66,
    cy: 38,
    fill: "#FFFFFE",
    rx: 8,
    ry: 7
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.5,
    cy: 22.5,
    fill: "#FFFFFE",
    rx: 30.5,
    ry: 22.5
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFCA52",
    fontFamily: "Bosk, Bosk Test",
    fontSize: 26,
    letterSpacing: 2.058
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 104,
    y: 27
  }, "HI!")))));
}

export default __webpack_public_path__ + "./fonts/chatbot-guy-transparent.1d469f47cdbb924bf66360abf52350f1.svg";
export { SvgChatbotGuyTransparent as ReactComponent };